import { Http } from '@/utils/request';
import { UserInfo, IActivateUserRoleParams, IActivateUserRoleResult } from './type.d';

export const fetchUserInfo = async () => {
  return await Http.get(`open-app-bff/users/me`).json<APIRes<UserInfo>>();
};

export const logout = async () => {
  return await Http.post('account-user-bff/v1/users/logout', {
    json: {},
  }).json<APIRes>();
};

export const activateUserRole = async (params: IActivateUserRoleParams) => {
  return await Http.post('account-user-bff/v1/users/platform/active', {
    json: params,
  }).json<APIRes<IActivateUserRoleResult>>();
};

//激活邮箱
export const activateEmail = async (params: { teamId: string; appId: string; account: string }) => {
  return await Http.get(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/account/${params.account}/active`
  ).json<APIRes<never>>();
};
